var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8684",
    "data-name": "Group 8684",
    transform: "translate(-756 -281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2157",
    "data-name": "Ellipse 2157",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(756 281)",
    fill: "#e6f0e1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Tick_Square",
    "data-name": "Iconly/Bold/Tick Square",
    transform: "translate(785 310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick_Square",
    "data-name": "Tick Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tick_Square-2",
    "data-name": "Tick Square",
    d: "M22.944,32H9.072C3.646,32,0,28.2,0,22.546V9.472C0,3.807,3.646,0,9.072,0H22.944C28.361,0,32,3.807,32,9.472V22.546C32,28.2,28.361,32,22.944,32ZM10.3,14.6a1.4,1.4,0,0,0-.991,2.393l3.807,3.792a1.41,1.41,0,0,0,1.969,0l7.6-7.6A1.4,1.4,0,0,0,20.7,11.2L14.1,17.809l-2.8-2.8A1.389,1.389,0,0,0,10.3,14.6Z",
    fill: "#4fa531"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/reset-password.ece1c00e3dbbf16aad38cb805e10e961.svg";
export { ForwardRef as ReactComponent };